<template>
  <div class="ab-f">
    <div class="ab-head">
      <h3>{{ (test ? 'Правка · ' : '') + (d.kind === 'prepost' ? 'Тест до / после' : 'A/B тест') }}</h3>
      <span class="ab-note">{{ column.label }}</span>
      <button type="button" class="ab-x" aria-label="закрыть" @click="$emit('cancel')">✕</button>
    </div>

    <div class="ab-r"><label class="ab-k">основа</label>
      <span class="ab-chip-col">{{ column.label }}</span>
      <span class="ab-note">{{ colSes.length }} {{ ses(colSes.length) }} · {{ fmt(colFlow) }} в день{{ column.seg ? ' · сегмент' : '' }}</span>
    </div>

    <!-- Вид стоит сразу после основы: он решает, есть ли с кем сравнивать, и меняет половину полей ниже. -->
    <div class="ab-r"><label class="ab-k">вид теста</label>
      <span class="ab-seg">
        <button type="button" :aria-pressed="d.kind === 'ab'" @click="d.kind = 'ab'">A/B</button>
        <button type="button" :aria-pressed="d.kind === 'prepost'" @click="d.kind = 'prepost'">до / после</button>
      </span>
      <span class="ab-note">{{ d.kind === 'prepost'
        ? 'трафик не делится: сравниваем этот же столбец с самим собой во времени'
        : 'трафик делится на две ветки, они идут одновременно' }}</span>
    </div>
    <div v-if="d.kind === 'prepost'" class="ab-r"><label class="ab-k">период до</label>
      <span class="ab-nw"><input v-model.number="d.before" type="number" min="1" max="120" aria-label="период до"> дн.</span>
      <span class="ab-note">{{ beforeSes.length
        ? 'в окне ' + beforeSes.length + ' ' + ses(beforeSes.length) + ' за ' + (beforeWin[1] - beforeWin[0] + 1) + ' дн., это и есть база сравнения'
        : 'в этом окне сессий нет, возьмите период шире' }}</span>
    </div>
    <div v-else class="ab-r"><label class="ab-k">контроль</label>
      <select v-model="d.control" aria-label="контроль">
        <option value="all">все сессии</option>
        <option value="rest">остальные столбцы</option>
        <option v-for="c in controlCols" :key="c.key" :value="c.key">{{ c.label }}</option>
        <option v-if="lostControl" :value="d.control">{{ lostControl }}</option>
      </select>
    </div>

    <div class="ab-r"><label class="ab-k">блок воронки</label>
      <span class="ab-seg">
        <button v-for="(b, i) in blocks" :key="i" type="button" :title="b" :aria-pressed="d.block === i" @click="d.block = i">{{ i + 1 }}</button>
      </span>
    </div>
    <div class="ab-r"><label class="ab-k">что меняем</label>
      <button type="button" class="ab-tg2" :aria-pressed="d.grid" @click="d.grid = !d.grid">сетка по блокам</button>
      <span v-if="d.grid" class="ab-seg">
        <button type="button" :aria-pressed="d.gridUnit === 'share'" @click="d.gridUnit = 'share'">доли</button>
        <button type="button" :aria-pressed="d.gridUnit === 'n'" @click="d.gridUnit = 'n'">штуки</button>
      </span>
      <button type="button" class="ab-tg2" :aria-pressed="d.spark" @click="d.spark = !d.spark">ушедшие по шагам</button>
    </div>
    <div class="ab-r"><label class="ab-k"></label>
      <span class="ab-note">у каждой фразы свой текст: слева тот, что показывается сейчас, ниже чем заменить. Пустые поля значат «оставить как есть».</span>
    </div>

    <div class="ab-r">
      <span class="ab-note">участвует {{ chosenPhrases.length }} из {{ column.phrases.length }} фраз</span>
      <button type="button" class="ab-tg2" @click="setAll(true)">все</button>
      <button type="button" class="ab-tg2" @click="setAll(false)">снять все</button>
    </div>
    <div class="ab-parts">
      <div v-for="f in shown" :key="f.phrase" class="ab-part" :class="{ 'ab-off': !d.chosen[f.phrase] }">
        <button type="button" class="ab-chk" aria-label="участвует в тесте" :aria-pressed="!!d.chosen[f.phrase]"
                @click="d.chosen[f.phrase] = !d.chosen[f.phrase]">✓</button>
        <div class="ab-pn"><span class="ab-dot" :style="{ background: phVar(f.phrase) }"></span>{{ f.phrase }}
          <span class="ab-pstat">{{ f.n }} {{ ses(f.n) }} · {{ f.conv }} {{ conv(f.conv) }} за период</span></div>
        <!-- «Сейчас» — текущие правила балансировщика для страницы этого токена (просьба заказчика);
             если их нет, самый частый текст из сессий периода. -->
        <div class="ab-now">
          <template v-if="f.now && (f.now.title || f.now.subtitle)">
            <b>{{ f.now.title || '—' }}</b><s>{{ f.now.subtitle || '—' }}</s>
            <em>сейчас на подмене{{ f.variants > 1 ? ' · в сессиях периода вариантов текста ' + f.variants : '' }}</em>
          </template>
          <template v-else-if="f.top">
            <b>{{ f.top.t }}</b><s>{{ f.top.s }}</s>
            <em>чаще всего в сессиях периода{{ f.variants > 1 ? ' · всего вариантов текста ' + f.variants : '' }}</em>
          </template>
          <template v-else>{{ balansirIndex ? 'на подмене для этой страницы заголовка нет' : 'загружаем правила балансировщика…' }}</template>
        </div>
        <div class="ab-new">
          <input v-model="texts[f.phrase].t" type="text" placeholder="новый заголовок, впишите или найдите существующий"
                 aria-label="новый заголовок" @focus="find = f.phrase" @input="find = f.phrase" @blur="hideFind(f.phrase)">
          <input v-model="texts[f.phrase].s" type="text" placeholder="новый подзаголовок" aria-label="новый подзаголовок">
          <div v-if="find === f.phrase && hints.length" class="ab-find">
            <button v-for="(h, j) in hints" :key="j" type="button" @mousedown.prevent="pick(f.phrase, h)">
              <b>{{ h.t }}</b><i>{{ h.s }}</i>
            </button>
          </div>
        </div>
        <div v-if="d.grid" class="ab-mg">
          <i v-for="(c, k) in f.cells" :key="k" :class="{ 'ab-pick': k === d.block }" :style="cellStyle(c.loss)"
             :title="'Блок ' + (k + 1) + ': ушло ' + c.gone + ' из ' + f.bn + ' · ' + Math.round(c.loss) + ' % · дошли ' + c.reached">{{ d.gridUnit === 'n' ? c.gone : Math.round(c.loss) }}</i>
          <u>{{ f.bn }} {{ ses(f.bn) }}</u>
        </div>
        <div v-if="d.spark" class="ab-sp">
          <b v-for="(v, k) in f.left" :key="k" :class="{ 'ab-pick': k === d.block }" :title="'Блок ' + (k + 1) + ': ушли ' + v">
            <em><s :style="{ '--h': Math.max(2, Math.round(v / maxLeft * 100)) + '%' }"></s></em><span>{{ v }}</span>
          </b>
        </div>
      </div>
      <!-- фразы теста, которых нет в столбце этого периода: сохраняются как есть, иначе пересохранение молча выкинет их из теста -->
      <div v-for="m in missing" :key="'x' + m.phrase" class="ab-part ab-off">
        <span></span>
        <div class="ab-pn">{{ m.phrase }}</div>
        <div class="ab-now">нет в текущем периоде, в тесте остаётся как есть</div>
        <div class="ab-now"><template v-if="m.text"><b>{{ m.text.title }}</b><s>{{ m.text.subtitle }}</s></template></div>
      </div>
      <span v-if="!facts.length" class="ab-note">внутри нечего варьировать</span>
      <button v-if="facts.length > LIMIT" type="button" class="ab-tg2" @click="all = !all">
        {{ all ? 'только самые частые' : 'показать все фразы (' + facts.length + ')' }}
      </button>
    </div>

    <div class="ab-r"><label class="ab-k">метрика</label>
      <span class="ab-seg">
        <button v-for="m in METRICS" :key="m.k" type="button" :aria-pressed="d.metric === m.k" @click="d.metric = m.k">{{ m.name }}</button>
      </span>
    </div>
    <div class="ab-r"><label class="ab-k">ждём эффект</label>
      <span class="ab-nw"><input v-model.number="d.effect" type="number" min="1" max="200" step="1" aria-label="эффект"> %</span>
      <label class="ab-k ab-auto">α</label>
      <select v-model.number="d.alpha" aria-label="альфа"><option :value="10">0,10</option><option :value="5">0,05</option><option :value="1">0,01</option></select>
      <label class="ab-k ab-auto">мощность</label>
      <select v-model.number="d.power" aria-label="мощность"><option :value="80">80 %</option><option :value="90">90 %</option><option :value="95">95 %</option></select>
    </div>
    <div class="ab-r">
      <template v-if="d.kind === 'ab'"><label class="ab-k">разбиение</label>
        <span class="ab-seg">
          <button v-for="a in [50, 75, 90]" :key="a" type="button" :aria-pressed="d.split === a" @click="d.split = a">{{ a }}/{{ 100 - a }}</button>
        </span>
      </template>
      <label class="ab-k" :class="{ 'ab-auto': d.kind === 'ab' }">{{ d.kind === 'prepost' ? 'период после' : 'срок' }}</label>
      <span class="ab-nw"><input v-model.number="d.days" type="number" min="1" max="120" aria-label="срок"> дн.</span>
      <span v-if="d.kind === 'prepost'" class="ab-note">изменение уходит на всю группу, разбиения нет</span>
    </div>
    <div class="ab-r"><label class="ab-k">guardrail</label>
      <select v-model="d.guardKind" aria-label="guardrail">
        <option value="none">не следим</option>
        <option value="medBlock">медианный блок не хуже</option>
        <option value="conv">конверсия не ниже</option>
      </select>
      <span v-if="d.guardKind !== 'none'" class="ab-nw">
        <input v-model.number="d.guardValue" type="number" min="0" max="100" aria-label="порог">
        <span class="ab-note">{{ d.guardKind === 'medBlock' ? 'блок' : '%' }}</span>
      </span>
    </div>
    <div class="ab-r"><label class="ab-k">название</label><input v-model="d.name" type="text" aria-label="название"></div>
    <div class="ab-r"><label class="ab-k">гипотеза</label><input v-model="d.hypothesis" type="text" placeholder="что и почему ждём" aria-label="гипотеза"></div>

    <div class="ab-calc">
      <b>{{ calc.now === null ? '—' : fmt(calc.now) + calc.unit }}</b> сейчас у столбца
      <template v-if="calc.base !== null"> · <b>{{ fmt(calc.base) + calc.unit }}</b> {{ d.kind === 'prepost' ? 'за период до' : 'у контроля' }}
        <template v-if="calc.diff !== null"> · разница <b>{{ (calc.diff > 0 ? '+' : '') + fmt(calc.diff) + calc.unit }}</b></template></template>
      <template v-else-if="d.kind === 'prepost'"> · <span class="ab-warn">за период до сессий нет</span></template>
      <template v-if="calc.p1 === null"><br><span class="ab-warn">базовой доли нет, считать выборку не из чего</span></template>
      <template v-else-if="calc.p1 <= 0 || calc.p1 >= 1"><br><span class="ab-warn">базовая доля 0 или 100 %, считать выборку не из чего</span></template>
      <template v-else-if="calc.n === Infinity"><br><span class="ab-warn">эффект такой, что считать выборку не из чего, базовая доля {{ fmt(calc.p1 * 100) }} %</span></template>
      <template v-else>
        <br>нужно <b>{{ calc.n.toLocaleString('ru') }}</b> {{ ses(calc.n) }} на {{ d.kind === 'prepost' ? 'период' : 'ветку' }}
        <template v-if="calc.need !== null"> ≈ <span :class="{ 'ab-warn': calc.need > d.days }"><b>{{ calc.need }}</b> дн. при потоке {{ fmt(flow) }} в день</span></template>
        <br>за <b>{{ d.days }}</b> дн. {{ d.kind === 'prepost' ? '«после» ' : '' }}поймается эффект
        <span v-if="calc.mde === null" class="ab-warn">почти никакой, потока не хватает даже на удвоение</span>
        <template v-else>от <b>{{ fmt(calc.mde) }} %</b> к базе</template>
        <template v-if="!calc.share"><br><span class="ab-warn">метрика не доля, выборка посчитана по конверсии</span></template>
      </template>
    </div>

    <div class="ab-acts">
      <span class="ab-note ab-hint">Форма тексты в балансировщик не отправляет, их меняют руками. Запуск считается с момента сохранения, поэтому сохраняйте тест, когда новые правила уже стоят.</span>
      <span v-if="problem" class="ab-warn">{{ problem }}</span>
      <button type="button" class="btn" @click="$emit('cancel')">отмена</button>
      <button type="button" class="btn" :disabled="!!problem" @click="save('save-open')">сохранить и открыть срез</button>
      <button type="button" class="btn ab-prim" :disabled="!!problem" @click="save('save')">сохранить тест</button>
    </div>
  </div>
</template>

<script>
import { requiredN, mde, windowMetric, flowPerDay } from '@/utils/abtest';
import { normRule, shownNow, pickHeads } from '@/utils/sessions';
import { plural } from '@/utils/segments';

const SES = ['сессия', 'сессии', 'сессий'];
const CONV = ['конверсия', 'конверсии', 'конверсий'];
const METRICS = [
  { k: 'conv', name: 'конверсия', share: true },
  { k: 'reach', name: 'доля до блока', share: true },
  { k: 'medBlock', name: 'медианный блок', share: false },
  { k: 'gain', name: 'средний прирост', share: false },
];
const LIMIT = 30;
const ALL = [-Infinity, Infinity];
const PH = 6;
const topOf = m => { let best = null; for (const [k, v] of m) if (!best || v.c > best.c) best = v; return best; };

export default {
  name: 'AbForm',
  props: {
    column: { type: Object, required: true },         // К4
    sessions: { type: Array, required: true },        // К2[] всех сессий периода (контроль 'all' / 'rest' / ключ столбца)
    columns: { type: Array, default: () => [] },      // К4[] — все столбцы, включая сегменты: список контроля
    blocks: { type: Array, required: true },
    token: { type: String, default: '' },              // чьи правила подмены показывать как «сейчас»
    balansirIndex: { type: Map, default: null },      // Map фраза → записи балансировщика; null, пока грузится
    test: { type: Object, default: null },            // К8 для правки или null
    startBlock: { type: Number, default: null },
  },
  emits: ['save', 'save-open', 'cancel'],
  data() {
    const t = this.test;
    const chosen = Object.create(null), texts = Object.create(null);
    // Все ключи заводим заранее: создавать их при отрисовке значит менять состояние в render.
    this.column.phrases.forEach(p => { chosen[p] = !t; texts[p] = { t: '', s: '' }; });
    if (t) {
      t.parts.forEach(p => { chosen[p.phrase] = true; });
      t.texts.forEach(x => { if (texts[x.phrase]) texts[x.phrase] = { t: x.title || '', s: x.subtitle || '' }; });
    }
    const nb = this.blocks.length;
    // по умолчанию как в прототипе: блок выбранный в срезе или последний, название «<столбец> · блок N»
    const block = Number.isInteger(this.startBlock) ? this.startBlock : nb - 1;
    const has = k => t && t[k] !== undefined && t[k] !== null;
    return {
      METRICS, LIMIT,
      all: false, find: null,
      texts,
      d: {
        kind: t ? t.kind : 'ab',
        control: t ? t.control : 'all',
        before: t ? t.before : 14,
        block,
        // обе картинки в карточках по умолчанию сняты: форма и без них длинная
        grid: has('grid') ? t.grid : false, gridUnit: has('gridUnit') ? t.gridUnit : 'share', spark: has('spark') ? t.spark : false,
        chosen,
        metric: t ? t.metric : 'conv',
        effect: t ? t.effect : 5, alpha: t ? t.alpha : 5, power: t ? t.power : 80,
        split: t ? t.split : 50, days: t ? t.days : 14,
        // порог нового теста ставит created(): медианный блок столбца минус 1 (R53)
        guardKind: t ? t.guardrail.kind : 'medBlock', guardValue: t ? t.guardrail.value : 1,
        name: t ? t.name : this.column.label + ' · блок ' + (block + 1), hypothesis: t ? t.hypothesis : '',
      },
    };
  },
  created() {
    if (this.test) return;
    const nb = this.blocks.length;
    // R53: порог = медианный блок самого столбца за период минус 1 (только сессии с блоками).
    // С медианой контроля тест на неизменном трафике краснел сразу: окно «после» шумит на ±1 блок.
    const v = windowMetric(this.colSes, ALL, 'medBlock', 0, nb).value;
    this.d.guardValue = Math.min(nb, Math.max(1, Math.floor(v || 0) - 1));
  },
  computed: {
    phraseSet() { return new Set(this.column.phrases); },
    colSes() { return this.sessions.filter(s => this.phraseSet.has(s.phrase)); },
    // Расчёт идёт по отмеченным фразам: ровно этот набор уйдёт в тест и будет считаться в отчёте.
    selSes() {
      const set = new Set(this.chosenPhrases);
      return this.colSes.filter(s => set.has(s.phrase));
    },
    flow() { return flowPerDay(this.selSes); },
    // «основа» — весь столбец, как в прототипе: от галочек фраз не зависит (расчёт ниже идёт по отмеченным)
    colFlow() { return flowPerDay(this.colSes); },
    // Контроль: все сессии, остальные столбцы или любой другой столбец, включая сегменты (как в прототипе).
    controlCols() { return this.columns.filter(c => c.key !== this.column.key); },
    // Сохранённый контроль, столбца которого нет в периоде (старое 'w:<слово>'): своя опция, иначе select пустой.
    lostControl() {
      const c = this.d.control;
      if (c === 'all' || c === 'rest' || this.controlCols.some(x => x.key === c)) return null;
      return (c.startsWith('w:') ? c.slice(2) : c) + ' · столбца нет в периоде';
    },
    controlSes() {
      const c = this.d.control;
      if (c === 'all') return this.sessions;
      if (c === 'rest') return this.sessions.filter(s => !this.phraseSet.has(s.phrase));
      const col = this.columns.find(x => x.key === c);
      if (col) { const set = new Set(col.phrases); return this.sessions.filter(s => set.has(s.phrase)); }
      // столбца нет в периоде: 'w:<слово>' ищем по слову во фразе, иначе контроля нет
      const w = c.startsWith('w:') ? c.slice(2) : null;
      return w ? this.sessions.filter(s => s.phrase.split(/\s+/).includes(w)) : [];
    },
    // «Период до» в форме, как в прототипе: последние N дней данных столбца. «После» ещё не наступило,
    // отчёт потом берёт «до» как N дней перед окном «после» (splitWindows), так же, как прототип.
    beforeWin() {
      if (!this.colSes.length || !(this.d.before >= 1)) return null;
      let a = Infinity, b = -Infinity;
      this.colSes.forEach(s => { if (s.day < a) a = s.day; if (s.day > b) b = s.day; });
      return [Math.max(a, b - this.d.before + 1), b];
    },
    beforeSes() {
      const w = this.beforeWin;
      return w ? this.selSes.filter(s => s.day >= w[0] && s.day <= w[1]) : [];
    },
    // Метрики по одной воронке сессий (reached, convMask): форма и отчёт считают одинаково.
    facts() {
      const nb = this.blocks.length;
      const by = new Map();
      this.colSes.forEach(s => { if (!by.has(s.phrase)) by.set(s.phrase, []); by.get(s.phrase).push(s); });
      const out = this.column.phrases.map(phrase => {
        const list = by.get(phrase) || [], n = list.length;
        const texts = new Map();
        list.forEach(s => {
          if (s.title == null && s.subtitle == null) return;
          const t = s.title || '', st = s.subtitle || '', key = t + '\u0000' + st;
          const e = texts.get(key);
          if (e) e.c++; else texts.set(key, { t, s: st, c: 1 });
        });
        // сетка и «ушедшие» только по сессиям с блоками (reached = -1 не входят, как в решётке)
        const bn = list.filter(s => s.reached >= 0).length;
        const cells = [], left = [];
        for (let k = 0; k < nb; k++) {
          const reached = list.filter(s => s.reached >= k).length;
          cells.push({ reached, gone: bn - reached, loss: bn ? (bn - reached) / bn * 100 : 0 });
          left.push(list.filter(s => s.churn === k).length);
        }
        const conv = list.filter(s => s.convMask).length;
        const now = shownNow(this.balansirIndex, phrase, this.token);
        return { phrase, n, bn, conv, cells, left, top: topOf(texts), variants: texts.size, now };
      });
      return out.sort((a, b) => b.n - a.n);
    },
    shown() { return this.all ? this.facts : this.facts.slice(0, LIMIT); },
    maxLeft() { return this.facts.reduce((m, f) => Math.max(m, ...f.left), 1); },   // фраз может быть много — без спреда по ним
    // Пул текстов: правила балансировщика (заголовок + подзаголовок одного варианта) и то, что видели сессии.
    pool() {
      const m = new Map();
      const add = (t, s, phrase) => {
        if (!t) return;
        const k = t + '\u0000' + s;
        if (!m.has(k)) m.set(k, { t, s, phrases: new Set() });
        if (phrase) m.get(k).phrases.add(phrase);
      };
      if (this.balansirIndex) {
        this.balansirIndex.forEach((records, phrase) => records.forEach(r => {
          ['blockReWriteA', 'blockReWriteB'].forEach(f => {
            // те же правила выбора, что у показанного: роли, а без них первые два текста с буквами
            const [t, st] = pickHeads((r[f] || []).map(normRule));
            if (t) add(t, st || '', phrase);
          });
        }));
      }
      this.sessions.forEach(s => add(s.title, s.subtitle || '', s.phrase));
      return [...m.values()];
    },
    // Поиск как в прототипе: от двух символов, каждое слово запроса ищется в паре «заголовок + подзаголовок».
    hints() {
      if (this.find == null) return [];
      const norm = x => String(x || '').toLowerCase().replace(/ё/g, 'е').trim();
      const q = norm(this.texts[this.find] ? this.texts[this.find].t : '');
      if (q.length < 2) return [];
      const words = q.split(/[\s,]+/).filter(Boolean);
      const own = x => (x.phrases.has(this.find) ? 0 : 1);
      return this.pool.filter(x => { const f = norm(x.t + ' ' + x.s); return words.every(w => f.includes(w)); })
        .sort((a, b) => own(a) - own(b)).slice(0, 8);
    },
    calc() {
      const d = this.d, nb = this.blocks.length;
      const unit = d.metric === 'conv' || d.metric === 'reach' ? ' %' : d.metric === 'gain' ? ' п.п.' : '';
      const val = (list, metric) => windowMetric(list, ALL, metric, d.block, nb).value;
      const now = val(this.selSes, d.metric);
      const baseList = d.kind === 'prepost' ? this.beforeSes : this.controlSes;
      const base = baseList.length ? val(baseList, d.metric) : null;
      // База выборки как в прототипе: в A/B уровень самого столбца (от контроля не зависит),
      // в «до / после» его же уровень за период до. По доле; у не-долевых метрик берём конверсию.
      const share = METRICS.find(m => m.k === d.metric).share;
      const pList = d.kind === 'prepost' && this.beforeSes.length ? this.beforeSes : this.selSes;
      const pv = pList.length ? val(pList, share ? d.metric : 'conv') : null;
      const p1 = pv === null ? null : pv / 100;
      const n = p1 === null ? null : requiredN(p1, d.effect, d.alpha, d.power);
      const flow = this.flow * (d.kind === 'ab' ? Math.min(d.split, 100 - d.split) / 100 : 1);
      const need = n && n !== Infinity && flow > 0 ? Math.ceil(n / flow) : null;
      const m = p1 === null || !(flow > 0) ? null : mde(p1, flow * d.days, d.alpha, d.power);
      const diff = now === null || base === null ? null : Math.round((now - base) * 10) / 10;
      return { now, base, diff, unit, p1, n: n === null ? (p1 === null ? null : Infinity) : n, need, mde: m, flow, share };
    },
    problem() {
      if (!this.chosenPhrases.length) return 'отметьте хотя бы одну фразу';
      const d = this.d, nb = this.blocks.length;
      if (!(d.effect > 0)) return 'эффект должен быть больше нуля';
      if (!(d.days >= 1 && d.days <= 120)) return 'срок от 1 до 120 дней';
      if (d.kind === 'prepost' && !(d.before >= 1 && d.before <= 120)) return 'период до от 1 до 120 дней';
      if (d.guardKind === 'conv' && !(d.guardValue >= 0 && d.guardValue <= 100)) return 'порог конверсии от 0 до 100 %';
      if (d.guardKind === 'medBlock' && !(d.guardValue >= 1 && d.guardValue <= nb)) return 'порог блока от 1 до ' + nb;
      return '';
    },
    // Фразы сохранённого теста вне столбца текущего периода (К8 parts/texts), по одной на фразу.
    missing() {
      const t = this.test;
      if (!t) return [];
      const seen = new Set();
      return t.parts.filter(p => !this.phraseSet.has(p.phrase) && !seen.has(p.phrase) && seen.add(p.phrase))
        .map(p => ({ phrase: p.phrase, text: t.texts.find(x => x.phrase === p.phrase) || null }));
    },
    chosenPhrases() { return this.column.phrases.filter(p => this.d.chosen[p]); },
  },
  methods: {
    ses: n => plural(n, SES),
    conv: n => plural(n, CONV),
    fmt(v) { return v == null || !isFinite(v) ? '—' : String(Math.round(v * 10) / 10).replace('.', ','); },
    // цвет фразы постоянный: по её месту в столбце, как в отчёте
    phVar(phrase) { return 'var(--ph' + (Math.max(0, this.column.phrases.indexOf(phrase)) % PH) + ')'; },
    // Отток: чем больше потеряно к блоку, тем темнее клетка (одна шкала с числом в клетке).
    cellStyle(loss) {
      const s = loss < 10 ? 0 : loss < 30 ? 20 : loss < 50 ? 40 : loss < 70 ? 60 : loss < 90 ? 80 : 100;
      return { background: 'var(--seq-' + s + ')', color: 'var(--seq-ink-' + s + ')' };
    },
    setAll(v) { this.column.phrases.forEach(p => { this.d.chosen[p] = v; }); },
    pick(p, h) { const n = this.texts[p]; n.t = h.t; n.s = h.s; this.find = null; },
    hideFind(p) { setTimeout(() => { if (this.find === p) this.find = null; }, 120); },
    save(ev) {
      const d = this.d, t = this.test;
      const word = this.column.word || this.column.label;
      // фразы теста вне текущего столбца уходят обратно как были (см. missing)
      const keep = t ? t.parts.filter(p => !this.phraseSet.has(p.phrase)) : [];
      const parts = this.chosenPhrases.map(phrase => ({ word, phrase })).concat(keep);
      const texts = this.chosenPhrases.filter(p => this.texts[p] && (this.texts[p].t || this.texts[p].s))
        .map(phrase => ({ phrase, title: this.texts[phrase].t, subtitle: this.texts[phrase].s }))
        .concat(t ? t.texts.filter(x => !this.phraseSet.has(x.phrase)) : []);
      const out = {
        ...(t ? { id: t.id } : {}),
        name: d.name.trim() || (this.column.label + ' · ' + (d.kind === 'prepost' ? 'до / после' : 'A/B')),
        hypothesis: d.hypothesis, kind: d.kind,
        columnKey: this.column.key, parts, block: d.block,
        metric: d.metric, effect: d.effect, alpha: d.alpha, power: d.power,
        split: d.split, days: d.days, before: d.before >= 1 ? d.before : 14,
        guardrail: { kind: d.guardKind, value: d.guardKind === 'none' ? 0 : Number(d.guardValue) || 0 },
        texts, control: d.kind === 'ab' ? d.control : 'all',
        grid: d.grid, spark: d.spark, gridUnit: d.gridUnit,
        startedAt: t ? t.startedAt : Date.now(),
        finishedAt: t ? t.finishedAt : null,
        windows: t ? t.windows : null,
      };
      this.$emit(ev, out);
    },
  },
};
</script>

<style>
.ins-root .ab-f{font-size:12.5px; line-height:1.4; color:var(--text-secondary); display:grid; gap:10px;}
.ins-root .ab-head{display:flex; align-items:center; gap:8px;}
.ins-root .ab-head h3{font-size:14px; font-weight:700; margin:0; color:var(--text-primary);}
.ins-root .ab-head .ab-x{margin-left:auto; border:0; background:transparent; color:var(--text-muted); cursor:pointer; font-size:15px; line-height:1; padding:2px 4px;}
.ins-root .ab-r{display:flex; flex-wrap:wrap; align-items:center; gap:8px;}
.ins-root .ab-k{min-width:92px; color:var(--text-muted); font-size:11.5px; margin:0;}
.ins-root .ab-k.ab-auto{min-width:auto;}
.ins-root .ab-nw{display:inline-flex; align-items:center; gap:5px; white-space:nowrap;}
.ins-root .ab-note{color:var(--text-muted); font-size:11.5px;}
.ins-root .ab-warn{color:var(--text-muted);}
.ins-root .ab-chip-col{border:1px solid var(--accent); color:var(--accent); border-radius:20px; padding:2px 9px; font-size:11.5px;
  font-weight:600; white-space:nowrap;}
.ins-root .ab-seg{display:inline-flex; border:1px solid var(--border); border-radius:8px; overflow:hidden;}
.ins-root .ab-seg button{border:0; background:var(--surface-1); color:var(--text-secondary); padding:5px 9px; cursor:pointer; font:inherit; font-size:12px;
  border-right:1px solid var(--border);}
.ins-root .ab-seg button:last-child{border-right:0;}
.ins-root .ab-seg button[aria-pressed="true"]{background:var(--accent); color:var(--on-accent); font-weight:600;}
.ins-root .ab-tg2{border:1px solid var(--border); border-radius:20px; background:var(--surface-1); color:var(--text-secondary);
  padding:3px 10px; cursor:pointer; font:inherit; font-size:11.5px;}
.ins-root .ab-tg2[aria-pressed="true"]{background:var(--accent); border-color:var(--accent); color:var(--on-accent);}
.ins-root .ab-f input[type=text], .ins-root .ab-f input[type=number], .ins-root .ab-f select{border:1px solid var(--border); border-radius:7px;
  background:var(--surface-1); color:var(--text-primary); padding:5px 8px; font:inherit;}
.ins-root .ab-f input[type=text]{flex:1; min-width:170px;}
.ins-root .ab-f input[type=number]{width:64px;}
.ins-root .ab-parts{display:flex; flex-direction:column; gap:8px;}
/* карточка фразы в две колонки, как в прототипе: галочка слева, всё остальное столбиком справа */
.ins-root .ab-part{display:grid; grid-template-columns:auto 1fr; gap:5px 10px; align-items:start;
  border:1px solid var(--border); border-radius:10px; padding:8px 10px; background:var(--surface-1);}
.ins-root .ab-part.ab-off{opacity:.5;}
.ins-root .ab-part > .ab-now, .ins-root .ab-part > .ab-new, .ins-root .ab-part > .ab-mg, .ins-root .ab-part > .ab-sp{grid-column:2;}
.ins-root .ab-chk{width:18px; height:18px; border:1px solid var(--border); border-radius:5px; background:var(--page); color:transparent;
  font-size:11px; line-height:1; padding:0; cursor:pointer;}
.ins-root .ab-chk[aria-pressed="true"]{background:var(--accent); border-color:var(--accent); color:var(--on-accent);}
.ins-root .ab-pn{font-weight:650; color:var(--text-primary); word-break:break-word;}
.ins-root .ab-dot{display:inline-block; width:8px; height:8px; border-radius:50%; margin-right:6px;}
.ins-root .ab-now{font-size:11.5px; color:var(--text-muted); line-height:1.35;}
.ins-root .ab-now b{display:block; color:var(--text-secondary); font-weight:600;} .ins-root .ab-now s{display:block; text-decoration:none;}
.ins-root .ab-pstat{font-weight:400; font-size:11.5px; color:var(--text-muted); margin-left:8px; white-space:nowrap;}
.ins-root .ab-now em{display:block; font-style:normal; opacity:.8; margin-top:1px;}
.ins-root .ab-new{position:relative; display:flex; flex-direction:column; gap:5px; margin-top:3px;}
.ins-root .ab-new input{min-width:0 !important; width:100%;}
.ins-root .ab-find{position:absolute; top:calc(50% - 2px); left:0; right:0; z-index:5; background:var(--page); border:1px solid var(--border);
  border-radius:9px; box-shadow:0 8px 20px var(--shadow-md); max-height:210px; overflow:auto; padding:3px;}
.ins-root .ab-find button{display:block; width:100%; text-align:left; border:0; background:transparent; color:var(--text-primary);
  padding:5px 8px; cursor:pointer; font:inherit; font-size:11.5px; border-radius:6px; line-height:1.3;}
.ins-root .ab-find button:hover{background:var(--surface-1);}
.ins-root .ab-find i{display:block; font-style:normal; color:var(--text-muted); font-size:10.5px;}
.ins-root .ab-mg{display:flex; flex-wrap:wrap; gap:2px; align-items:center; margin-top:3px;}
.ins-root .ab-mg i{font-style:normal; width:30px; height:18px; display:flex; align-items:center; justify-content:center; border-radius:4px; font-size:9.5px;
  font-variant-numeric:tabular-nums;}
.ins-root .ab-mg i.ab-pick{outline:2px solid var(--text-primary); outline-offset:-2px;}
.ins-root .ab-sp b.ab-pick s{outline:2px solid var(--text-primary); outline-offset:1px;}
.ins-root .ab-mg u{text-decoration:none; color:var(--text-muted); font-size:9.5px; margin-left:6px;}
.ins-root .ab-sp{display:flex; gap:3px; align-items:flex-end; margin-top:4px; flex-wrap:wrap;}
.ins-root .ab-sp b{display:flex; flex-direction:column; align-items:center; font-weight:400; width:30px; gap:2px;}
.ins-root .ab-sp em{display:flex; align-items:flex-end; height:26px; width:100%;}
.ins-root .ab-sp s{display:block; width:100%; height:var(--h); background:var(--div-neg); border-radius:3px 3px 0 0; text-decoration:none;}
.ins-root .ab-sp span{font-size:9.5px; color:var(--text-muted);}
.ins-root .ab-calc{border:1px dashed var(--border); border-radius:9px; padding:8px 10px; font-size:12px; color:var(--text-primary);
  background:var(--surface-1);}
.ins-root .ab-calc b{font-variant-numeric:tabular-nums;}
.ins-root .ab-acts{display:flex; flex-wrap:wrap; justify-content:flex-end; align-items:center; gap:8px; margin-top:2px;}
/* Причина блокировки своей строкой: кнопки всегда в ряд, как в П. */
.ins-root .ab-acts .ab-hint{flex-basis:100%; text-align:right;}
.ins-root .ab-acts .ab-warn{flex-basis:100%; text-align:right; font-size:12px;}
/* кнопки окон A/B высотой как в П: bootstrap даёт .btn margin 1px, страница line-height 1.2 */
.ins-root .ab-f .btn{line-height:1.4; margin:0;}
.ins-root .btn.ab-prim{background:var(--accent); color:var(--on-accent); border-color:var(--accent); font-weight:600;}
</style>
